import type { TriyoRolePrivilege, TriyoUser } from "@/types/models";

export const TRIYO_MENU_ITEMS = {
  projects: "Projects",
  taskManagement: "Task Management",
} as const;

export type TriyoPrivilegeAction = "View" | "Add" | "Edit" | "Delete" | "Detail";

function isActive(privilege: TriyoRolePrivilege): boolean {
  return privilege.IsActive === 1;
}

/**
 * Uses the same role-privilege rows and menu-item names as Triyo.Web. Missing,
 * inactive, or explicitly denied privileges fail closed, matching API checks.
 */
export function hasRolePrivilege(
  user: TriyoUser | null | undefined,
  menuItem: string,
  action: TriyoPrivilegeAction
): boolean {
  return (
    user?.RolePrivilege?.some(
      (privilege) => privilege.MenuItem === menuItem && isActive(privilege) && privilege[action] === true
    ) ?? false
  );
}

export interface WorkflowAccess {
  canViewDeals: boolean;
  canCreateDeals: boolean;
  canViewDealDetails: boolean;
  canEditDeals: boolean;
  canViewTasks: boolean;
}

export function getWorkflowAccess(user: TriyoUser | null | undefined): WorkflowAccess {
  return {
    canViewDeals: hasRolePrivilege(user, TRIYO_MENU_ITEMS.projects, "View"),
    canCreateDeals: hasRolePrivilege(user, TRIYO_MENU_ITEMS.projects, "Add"),
    canViewDealDetails: hasRolePrivilege(user, TRIYO_MENU_ITEMS.projects, "Detail"),
    canEditDeals: hasRolePrivilege(user, TRIYO_MENU_ITEMS.projects, "Edit"),
    canViewTasks: hasRolePrivilege(user, TRIYO_MENU_ITEMS.taskManagement, "View"),
  };
}
